import { useState } from "react";

import appStyles from "../App.module.css";
import Popup from "../business-travel/components/Popup";
import BenefitSummaryTableModal from "../business-travel/components/modal/BenefitSummaryTableModal";

const BusinessTravelBenefitButton = ({ version }: any) => {
  const [showBenefitSummaryModal, setShowBenefitSummaryModal] =
    useState<boolean>(false);
  return (
    <div>
      <button
        className={`${appStyles.btBtnOutline}`}
        onClick={() => setShowBenefitSummaryModal(true)}>
        SEE BENEFITS
      </button>
      {showBenefitSummaryModal && (
        <Popup
          onClose={() => {
            setShowBenefitSummaryModal(false);
          }}
          title=''
          styleBenefitModal={true}
          children={<BenefitSummaryTableModal version={version} />}
        />
      )}
    </div>
  );
};

export default BusinessTravelBenefitButton;
